<template>
  <el-menu class="navbar" mode="horizontal">
    <hamburger
      class="hamburger-container"
      :toggleClick="toggleSideBar"
      :isActive="sidebar.opened"
    ></hamburger>
    <breadcrumb></breadcrumb>
    <h2
      style="
        position: absolute;
        right: 700px;
        top: -20px;
        color: #2874cc;
        text-align: center;
      "
    >
      智能精准饲喂系统平台
    </h2>
    <div style="position: absolute; right: 200px; top: 0; color: #fff">{{ nowTime }}</div>
    <div style="position: absolute; right: 115px; top: 0; color: #fff">
      {{ $store.state.user.name }}
    </div>
    <el-dropdown class="avatar-container" trigger="click">
      <div class="avatar-wrapper">
        <img
          class="user-avatar"
          :src="$store.state.user.avatar? api + '/avatar/' + $store.state.user.avatar: personImg"
        /><i class="el-icon-caret-bottom"></i>
      </div>
        <el-tooltip
        content="全屏缩放"
        effect="dark"
        placement="bottom"
        style="position: absolute; left: 65px; top: 2px">
        <screenfull id="Screenfull" class="right-menu-item hover-effect" /></el-tooltip>
   <el-dropdown-menu class="user-dropdown" slot="dropdown">
        <router-link class="inlineBlock" to="/">
          <el-dropdown-item>首页</el-dropdown-item>
        </router-link>
        <router-link class="inlineBlock" to="/centers">
          <el-dropdown-item>个人中心</el-dropdown-item>
        </router-link>
        <el-dropdown-item divided>
          <span @click="logout" style="display: block">退出</span>
        </el-dropdown-item>
      </el-dropdown-menu>
       
    </el-dropdown>
  </el-menu>
</template>

<script>
import { mapGetters, mapState } from "vuex";
import { timeNow } from "../../../utils/date";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";
import Screenfull from "@/components/Screenfull";
import personImgs from "../../../../static/imags/person.png";
export default {
  data() {
    return {
      api: process.env.BASE_API,
      personImg: personImgs,
      tiemEq: "",
      nowTime: "",
    };
  },
  components: {
    Breadcrumb,
    Screenfull,
    Hamburger,
  },
  computed: {
    ...mapGetters(["sidebar"]),
  },
  mounted() {
    this.tiemEq = setInterval(() => {
      /* 时间 */
      this.nowTime = timeNow();
    }, 1000);
  },
  beforeDestroy() {
    clearInterval(this.tiemEq);
  },
  methods: {
    toggleSideBar() {
      this.$store.dispatch("ToggleSideBar");
    },
    logout() {
      this.$store.dispatch("LogOut").then(() => {
        location.reload(); // 为了重新实例化vue-router对象 避免bug
      });
    },
  },
};
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
.navbar {
  height: 50px;
  line-height: 50px;
  border-radius: 0px !important;

  .right-menu-item {
    display: inline-block;
    padding: 0 8px;
    height: 100%;
    font-size: 18px;
    color: #5a5e66;
    vertical-align: text-bottom;

    &.hover-effect {
      cursor: pointer;
      transition: background 0.3s;

      &:hover {
        background: rgba(0, 0, 0, 0.025);
      }
    }
  }

  .hamburger-container {
    line-height: 58px;
    height: 50px;
    float: left;
    padding: 0 10px;
  }
  // .screenfull {
  //   position: absolute;
  //   right: 90px;
  //   top: 16px;
  //   color: red;
  // }
  .avatar-container {
    height: 50px;
    display: inline-block;
    position: absolute;
    right: 35px;
  }

  .avatar-wrapper {
    cursor: pointer;
    margin-top: 5px;
    position: relative;
    .user-avatar {
      width: 40px;
      height: 40px;
      margin-right: 40px;
      border-radius: 10px;
    }
    .el-icon-caret-bottom {
      position: absolute;
      right: -20px;
      top: 25px;
      font-size: 12px;
      margin-right: 35px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/layout/components/Navbar.vue